<template>
	<div class="search-form-wr" :class="{ 'focus': focused}">
		<div class="search-form">
			<input class="search-input" type="text" name="search" autocomplete="off" :placeholder="placeholder" v-model="queryInput" v-on:keyup.enter="submit" @focus="onFocus" @blur="onBlur">
			<button type="submit" class="search-ico search-btn" @click="submit">
				<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="17" viewBox="0 0 16 17" fill="#fff" class="injected-svg inject-me"><defs><path id="qoata" d="M71.64 580.2l-4.14-4.24a6.71 6.71 0 0 0 1.5-4.29c0-3.68-2.9-6.67-6.5-6.67s-6.5 2.99-6.5 6.67c0 3.7 2.9 6.68 6.5 6.68 1.27 0 2.43-.39 3.42-1.02l4.25 4.35c.2.21.48.32.72.32s.51-.1.72-.32c.4-.42.4-1.09.03-1.47m-9.1-3.97a4.5 4.5 0 0 1-4.45-4.57 4.5 4.5 0 0 1 4.45-4.56 4.5 4.5 0 0 1 4.45 4.56 4.52 4.52 0 0 1-4.45 4.57"></path></defs><g><g transform="translate(-56 -565)"><use xlink:href="#qoata"></use></g></g></svg>
			</button>
			<div class="input-borders"></div>
		</div>
	</div>
</template>

<script>
import debounce from 'lodash.debounce';
import { mapMutations, mapGetters } from 'vuex';

export default {
  props: ["placeholder", "submit"],

  data() {
    return {
      queryInput: '',
      focused: false
    }
  },

  watch: {
    queryInput() {
      this.debouncedSearchQueryCommit();
    }
  },

  created() {
    this.queryInput = this.searchQuery;
    const debouncedSearchQueryCommit = this.debouncedSearchQueryCommit;
    this.debouncedSearchQueryCommit = debounce(debouncedSearchQueryCommit, 300);
  },

  computed: {
    ...mapGetters(['searchQuery'])
  },

  methods: {
    ...mapMutations(['setSearchQuery']),

    debouncedSearchQueryCommit() {
      this.setSearchQuery(this.queryInput);
    },
    onFocus() {
      this.focused = true
    },
    onBlur() {
	    if (this.queryInput) {
        this.focused = true
      } else {
      	this.focused = false
      }
    }
  }
};
</script>
